module.exports = __webpack_public_path__ + "media/application/images/travel-1f31da7485909e3af1603f2841d0ba85.jpg";